export default "__VITE_ASSET__MB_$LV7M__"